<div matDialogTitle>Öppna för redigering</div>
<mat-dialog-content>
  <div>Handläggare:</div>
  <div [style.margin-bottom.px]="12">{{ customerService.currentCustomer$.value?.user?.name }}
  </div>
  <div>Låntagare:</div>
  @if (customerService.currentCustomer$.value!.saveData!.applicants!.applicants!.length > 0) {
    @for (
      applicant of customerService.currentCustomer$.value?.saveData?.applicants?.applicants; track applicant.name) {
      <div>{{ applicant.name }}</div>
    }
  }

  <p>Kund ska åter välja om råd följs eller inte.
    Rådgivningsdokumentation ska produceras
    på nytt till kund. Är du säker på att du vill redigera denna rådgivning?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close matButton="outlined">Avbryt</button>
  <button
    (click)="unLockAdvice()"
    mat-dialog-close
    matButton="filled">Ja
  </button>
</mat-dialog-actions>